const tableData = [
  {
    id: 1,
    accused: "Emmanuel Amakom & 4 Others",
    offense: "Fraud",
    type: "fraud",
    amount: "N15,200,000.00",
    presidingJudge: "Hon. Justice I.B. Gafai",
    court: "Federal High Court, Awka, Anambra",
    agency: "EFCC",
    date: "25 June 2020"
  },
  {
    id: 3,
    accused: "Okafor James & 3 Others",
    offense: "Bribery",
    type: "bribery",
    amount: "N15,200,000.00",
    presidingJudge: "Hon. Justice U. Abiola",
    court: "Federal High Court, Wuse II Abuja FCT.",
    agency: "ICPC",
    date: "26 June 2020"
  },
  {
    id: 3,
    accused: "Osagie Aghedo & 2 Others",
    offense: "Money Laundering",
    type: "ml",
    amount: "N15,200,000.00",
    presidingJudge: "Hon. Justice M.A. Olayinka",
    court: "Federal High Court, Barnawa, Kaduna",
    agency: "EFCC",
    date: "28 June 2020"
  },
  {
    id: 4,
    accused: "Danjuma Sheu & 4 Others",
    offense: "Fraud",
    type: "fraud",
    amount: "N15,200,000.00",
    presidingJudge: "Hon. Justice I.B. Gafai",
    court: "Federal High Court, Awka, Anambra",
    agency: "EFCC",
    date: "27 June 2020"
  }
];
export default tableData;
